// Launch A uses payments arranged directly with the provider for every workspace.
export const CARD_CHECKOUT_ENABLED = false;
export const PAY_OUTSIDE_COPY = "Pay your coach or organizer directly — they'll mark it as paid in TARK.";
